import { TRANSITIONS, TransitionType } from 'enums'

export const isDipTransition = (type: TransitionType) => {
  switch (type) {
    case TRANSITIONS.DIP_BLACK:
    case TRANSITIONS.DIP_WHITE:
      return true
    default:
      return false
  }
}
